export default {"src":"/_next/static/media/healthcare-firms-erp-software.634bc041.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};